import Vue from 'vue'
import VueRouter from 'vue-router'
import PageLogin from '../views/Login'
import PageForgetpwd from '../views/Forgetpwd'
import PageBasic from '../views/Basic'
import PageTeam from '../views/Team'
import PageInstructor from '../views/Instructor'
import PageWorks from '../views/Works'
import PageTraining from '../views/Training'
import PageSubmit from '../views/Submit'
import PageResult from '../views/Result'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/basic'
  },
  {
    path: '/login',
    name: 'PageLogin',
    component: PageLogin,
    meta: {
      title: '登录'
    }
  },
  {
    path: '/forgetpwd',
    name: 'PageForgetpwd',
    component: PageForgetpwd,
    meta: {
      title: '重置密码'
    }
  },
  {
    path: '/basic',
    name: 'PageBasic',
    component: PageBasic,
    meta: {
      title: '基本信息'
    }
  },
  {
    path: '/team',
    name: 'PageTeam',
    component: PageTeam,
    meta: {
      title: '参赛者'
    }
  },
  {
    path: '/instructor',
    name: 'PageInstructor',
    component: PageInstructor,
    meta: {
      title: '指导教师'
    }
  },
  {
    path: '/works',
    name: 'PageWorks',
    component: PageWorks,
    meta: {
      title: '上传作品'
    }
  },
  {
    path: '/training',
    name: 'PageTraining',
    component: PageTraining,
    meta: {
      title: '培训考试意向'
    }
  },
  {
    path: '/submit',
    name: 'PageSubmit',
    component: PageSubmit,
    meta: {
      title: '提交报名'
    }
  },
  {
    path: '/result',
    name: 'PageResult',
    component: PageResult,
    meta: {
      title: '报名结果'
    }
  }
]

const router = new VueRouter({
  routes,
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  let title = window.regConfig.reg_name
  if (to.meta && to.meta.title) {
    title = to.meta.title + ' - ' + title
  }
  document.title = title
  next()
})

export default router
